import ConsumerRootContentSearch from './ConsumerRootContentSearch';

export default ConsumerRootContentSearch;
